<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.TRUSTEE_FOREIGN_ORGANIZATION,
        })
      "
    ></WrapperField>

    <TitleField
      fieldName="isAssignee"
      :fieldGroup="FieldGroup.FOREIGN_ORGANIZATION"
    />
    <AssigneeSection :data="data.assignee" />
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import AssigneeSection from '@/components/elements/statement/FullStatementView/elements/Assignee';

export default {
  name: 'TrusteeForeignOrganization',
  components: {
    WrapperField,
    TitleField,
    AssigneeSection,
  },
  props: ['data'],
  data: () => ({
    FieldGroup,
    createDataField,
  }),
};
</script>
